import React, { Component } from "react";
// import AccountDataService from "../services/account-activities";
// import { Redirect } from "react-router-dom";

import { Redirect } from 'react-router';

import { connect } from 'react-redux';
import { LOGOUT } from '../../features/actions/Is-Logged-Actions';
import { UPDATE_ACTIVE_LINK } from '../../features/actions/Active-Nav-Link-Actions';

import { SET_REPORT_TENANT_VIEWING, ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN, ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN_WARNING_TICKETS } from "../../features/actions/Is-Logged-Actions";
import { ALERT_REPORT_TIMESPAN_CHANGE_DETECTED, ALERT_REPORT_RESOLVED_TIMESPAN_CHANGE_DETECTED, ALERT_REPORT_TIMESPAN_TYPE_CHANGE_DETECTED, ALERT_REPORT_ASSIGNED_TO_CHANGE_DETECTED } from "../../features/actions/Reports-Actions";

import Container from 'react-bootstrap/Container';

import Navbar from '../../components/Navbar';

import TimespanTickets from "../Report-Components/Timespan-Tickets";
import OverdueTickets from "../Report-Components/Overdue-Tickets";
import WarningTickets from "../Report-Components/Warning-Tickets";
import ResolvedTickets from "../Report-Components/Resolved-Tickets";
import ResolvedTicketCountByTech from '../Admin-Dashboard/Widgets/Tickets/Resolved-Ticket-Count-By Tech';
import SurveyResults from "../Report-Components/Survey-Results";
import {
    Paper,
    Select,
    Button,
    Flex,
    Grid,
    Center,
    MultiSelect,
    Text
} from '@mantine/core';

import ReactSelect from 'react-select';

import dayjs from 'dayjs';

import { DatePickerInput } from '@mantine/dates';
import { store } from '../../app/store';

import Card from 'react-bootstrap/Card';

import { Link } from 'react-router-dom';

import ListGroup from 'react-bootstrap/ListGroup';
import { Form } from "react-bootstrap";

import HardwareAssetDataService from '../../services/hardware-asset-activities';

import NumberOfTicketsLast24Hours from "../Dashboard-Widgets/Number-of-Tickets-Last-24-Hours";
import NumberOfTicketsLastWeek from "../Dashboard-Widgets/Number-of-Tickets-Last-Week";

import PercentChangeTicketsLast24Hours from "../Dashboard-Widgets/Percent-Change-Number-Tickets-24-Hours";
import PercentChangeTicketsLastWeek from "../Dashboard-Widgets/Percent-Change-Number-Tickets-Last-Week";
import AssignTechsTicketsCalendarService from "../../services/assign-techs_tickets-calendar-activities";

import DashboardDataService from '../../services/dashboard-activities';     // DELETE THIS!!!


// uesd for react-select dark mode
const darkStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: '#2E2E2E',
    borderColor: '#424242',
    color: '#C1C2C5',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#424242',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#2E2E2E',
    color: '#C1C2C5',
    border: '1px solid #424242'
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#25262B',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#C1C2C5',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#C1C2C5',
    ':hover': {
      backgroundColor: '#339af0',
      color: 'white',
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#339af0'
      : state.isFocused
      ? '#242424'
      : '#2E2E2E',
    color: state.isSelected ? 'white' : '#C1C2C5',
    cursor: 'pointer',
  }),
  input: (provided) => ({
    ...provided,
    color: '#C1C2C5',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#C1C2C5',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#868E96',
  }),
};

// used for react-select light mode
const lightStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: '#F8F9FA',
    borderColor: state.isFocused ? '#228be6' : '#ced4da',
    color: '#212529',
    boxShadow: state.isFocused ? '0 0 0 1px #228be6' : 'none',
    '&:hover': {
      borderColor: '#228be6',
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#F8F9FA',
    // border: '1px solid #ced4da',
    zIndex: 9999,
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: '#F8F9FA',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#228be6'
      : state.isFocused
      ? '#F8F9FA'
      : '#F8F9FA',
    color: state.isSelected ? '#ffffff' : '#212529',
    cursor: 'pointer',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#e9ecef',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#212529',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#495057',
    ':hover': {
      backgroundColor: '#228be6',
      color: '#ffffff',
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: '#868e96',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#212529',
  }),
  input: (base) => ({
    ...base,
    color: '#212529',
  }),
};


function updateTimespan(timespan) {
    return {
        type: 'UPDATE_TIMESPAN',
        payload: timespan
    }
}

function updateResolvedTimespan(timespan) {
    return {
        type: 'UPDATE_RESOLVED_TIMESPAN',
        payload: timespan
    }
}

// alert functions will signal the child components (report widgets) that changes have been made to the filters so they update
// the child components will call the resolved varieties of these alerts to clear them
function alertTimespanChange() {
    return {
        type: "ALERT_REPORT_TIMESPAN_CHANGE_DETECTED"
    }
}

function alertResolvedTimespanChange() {
    return {
        type: "ALERT_REPORT_RESOLVED_TIMESPAN_CHANGE_DETECTED"
    }
}

function updateTimespanType(type) {
    return {
        type: 'UPDATE_TIMESPAN_TYPE',
        payload: type
    }
}

function alertTimespanTypeChange() {
    return {
        type: "ALERT_REPORT_TIMESPAN_TYPE_CHANGE_DETECTED"
    }
}

function updateTimespanAssignedTo(assignedTo) {
    return {
        type: 'UPDATE_TIMESPAN_ASSIGNEDTO',
        payload: assignedTo
    }
}

function alertTimespanAssignedToChange() {
    return {
        type: "ALERT_REPORT_ASSIGNED_TO_CHANGE_DETECTED"
    }
}

function updateTimespanAssignedToArray(newArray) {
    return {
        type: 'UPDATE_TIMESPAN_ASSIGNED_TO_ARRAY',
        payload: newArray
    }
}

function handleTimespanChange(timespan) {
    let state = store.getState();

    // If they changed to a different person than what is currently selected, do all this stuff, otherwise do nothing
    if (timespan && timespan !== state.reports.timespan && timespan.length > 1 && timespan[1] !== null) {

        //store.dispatch(resetDepartment());  // remove the old data so we free up space in the front end data store
        store.dispatch(updateTimespan(timespan));
        store.dispatch(alertTimespanChange());
    }
    console.log(timespan);
}

function handleResolvedTimespanChange(timespan) {
    let state = store.getState();

    // If they changed to a different person than what is currently selected, do all this stuff, otherwise do nothing
    if (timespan && timespan !== state.reports.resolved_timespan && timespan.length > 1 && timespan[1] !== null) {

        //store.dispatch(resetDepartment());  // remove the old data so we free up space in the front end data store
        store.dispatch(updateResolvedTimespan(timespan));
        store.dispatch(alertResolvedTimespanChange());
    }
    console.log(timespan);
}

function handleTimespanTypeChange(type) {
    let state = store.getState();

    // If they changed to a different person than what is currently selected, do all this stuff, otherwise do nothing
    if (type !== state.reports.timespanType) {

        //store.dispatch(resetDepartment());  // remove the old data so we free up space in the front end data store
        store.dispatch(updateTimespanType(type));
        store.dispatch(alertTimespanTypeChange());
    }
    console.log(type);
}

function handleTimespanAssignedToChange(assignedTo) {
    let state = store.getState();

    // If they changed to a different person than what is currently selected, do all this stuff, otherwise do nothing
    if (assignedTo !== state.reports.timespanAssignedTo) {

        //store.dispatch(resetDepartment());  // remove the old data so we free up space in the front end data store
        store.dispatch(updateTimespanAssignedTo(assignedTo));
        store.dispatch(alertTimespanAssignedToChange());
    }
    console.log(assignedTo);
}


class Reports extends Component {

    constructor(props) {
        super(props);
        let state = store.getState();

        this.setReportTenant = this.setReportTenant.bind(this);
        this.handleReportTenantChange = this.handleReportTenantChange.bind(this);

        var timespan = [state.reports.timespan[0] ? dayjs(Date.parse(state.reports.timespan[0])).$d : null, state.reports.timespan[1] ? dayjs(Date.parse(state.reports.timespan[1])).$d : null]
        var resolved_timespan = [state.reports.resolved_timespan[0] ? dayjs(Date.parse(state.reports.resolved_timespan[0])).$d : null, state.reports.resolved_timespan[1] ? dayjs(Date.parse(state.reports.resolved_timespan[1])).$d : null]
        this.state = {
            tenants: [{ id: 0, name_of_tenant: "All" }],     // the list of tenants the asking tech is authorized to see [{id: 1, name_of_tenant: "ProGroup"}]
            selectedTenant: "All",
            techList: [],
            timespan: timespan,
            resolved_timespan: resolved_timespan,
            timespanType: state.reports.timespanType,
            timespanAssignedTo: state.reports.timespanAssignedTo,

            timespanAssignedToArray: state.reports.timespanAssignedToArray
        }
    }

    componentDidMount() {

        if (this.props.loggedStatus.loggedIn) {
    
            HardwareAssetDataService.getTenants(this.props.loggedStatus.id).then(response => {
                console.log(response);
                this.setState({
                    tenants: [...this.state.tenants, ...response.data.results]
                }, () => {
                    //this.setReportTenant(this.state.tenants);   // update the global state with the tenant selected

                    /************* * DELETE THIS (and import line above) !!!! ***********/

                    // DashboardDataService.getTicketsIndividualMonth(token, this.props.loggedStatus.id, 2, "2023", this.props.loggedStatus.timezone_adjustment_factor).then(response => {
                    //     console.log("RESPONSE FROM GET TICKETS BY MONTH: ", response);
                    // });

                    // DashboardDataService.getTicketsByDayOfWeek(token, this.props.loggedStatus.id, 2, "4", "2023", this.props.loggedStatus.timezone_adjustment_factor).then(response => {
                    //     console.log("RESPONSE FROM GET TICKETS BY DAY OF WEEK: ", response);
                    // });

                    // DashboardDataService.getTicketsByHourOfDay(token, this.props.loggedStatus.id, 2, "0", "4", "2023", this.props.loggedStatus.timezone_adjustment_factor).then(response => {
                    //     console.log("RESPONSE FROM GET TICKETS BY HOUR OF DAY: ", response);
                    // });

                    // DashboardDataService.getTicketsBySLA(token, this.props.loggedStatus.id, 2, "", "", "2022-2024", this.props.loggedStatus.timezone_adjustment_factor).then(response => {
                    //     console.log("RESPONSE FROM GET TICKETS BY SLA: ", response);
                    // });

                    DashboardDataService.getSLAPerformance(this.props.loggedStatus.id, 2, "", "", "2023", this.props.loggedStatus.timezone_adjustment_factor).then(response => {
                        console.log("RESPONSE FROM GET SLA PERFORMANCE: ", response);
                    });

                    AssignTechsTicketsCalendarService.getTechsForMyTicketsTableDropdown(this.props.loggedStatus.id)
                    .then(response => {
                        console.log("Response from backend for tech list was: ");
                        console.log(response);
        
                        let updatedTechList = []
        
                        response.data.results.map((tech) => {
                            updatedTechList.push(tech);
                            return updatedTechList;   // included to appease compile warning. not actually needed
                        });
                        // NOTE: after the update, "All" is going to be represented by an empty assigned to array
                        this.setState({ techList: [/* {id: 0, primary_tenant_id: 0, tech_full_name: "All"}, */ {id: -1, primary_tenant_id: 0, tech_full_name: "Unassigned"}, ...updatedTechList] });
        
                    })
                    .catch(e => {
                        console.log(e);
                        console.log("You're in the CATCH clause of the assigned tech selector component. The line printed above should be the error text");
                        console.log("Should hopefully contain the status code of the failed attempt: ", e.response.status);
        
                        if (e.response.status === 401) {   // the token was stale, so try again after the state updates with the new token
                            console.log("The assigned tech selector is asking the API again since the token was stale");
                        }
                    });

                    });
                })
                    .catch(e => {
                        console.log(e);
                    });
            
            this.props.UPDATE_ACTIVE_LINK("reports");
        }
    }

    setReportTenant(tenantList) {

        if (tenantList && tenantList.length > 1) {     // if there was at least one tenant besides All in the list, pick the first one in the list that's not All as the default
            this.props.SET_REPORT_TENANT_VIEWING({ report_tenant_id_selected: tenantList[1].id, report_tenant_name_selected: tenantList[1].name_of_tenant });
            this.props.ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN();
            this.props.ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN_WARNING_TICKETS();
        }

        else {      // just use the only available item in the list (the "All" selection)
            this.props.SET_REPORT_TENANT_VIEWING({ report_tenant_id_selected: 0, report_tenant_name_selected: "All" });
            this.props.ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN();
            this.props.ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN_WARNING_TICKETS();
        }
    }


    // if user chooses different option from dropdown menu, go ahead and update the global state
    handleReportTenantChange(tenant_name) {
        // get a new access token first
            // if the token can't be refreshed, force a logout
           

        this.setState({ selectedTenant: tenant_name });

        //console.log(e.target.value);
        if (tenant_name !== this.props.loggedStatus.report_tenant_name_selected) {
            let newTenantId = this.state.tenants.find(o => o.name_of_tenant === tenant_name).id;

            this.props.SET_REPORT_TENANT_VIEWING({ report_tenant_id_selected: newTenantId, report_tenant_name_selected: tenant_name });

            this.props.ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN();
            this.props.ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN_WARNING_TICKETS();
        }


        // if(tenant_id !== this.props.loggedStatus.report_tenant_id_selected) {
        //     this.props.SET_REPORT_TENANT_VIEWING({report_tenant_id_selected: tenant_id, report_tenant_name_selected: tenant_name});

        //     this.props.ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN();
        //     this.props.ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN_WARNING_TICKETS();
        // }
    }

    // onChangeName(e) {
    //     this.setState({
    //         name: e.target.value
    //     });
    // }

    // saveAccount() {
    //     var data = {
    //         name: this.state.name
    //     };

    //     if(this.props.loggedStatus.loggedIn){
    //         this.props.onAccessTokenRequest(this.props.loggedStatus.username).then((token) => {
    //         this.props.ACCESSTOKEN(token);
    //         AccountDataService.create(data, token)
    //         .then(response => {
    //             this.props.history.push('/accounts');
    //         //console.log(response.data);
    //         // this.setState({
    //         //     redirect: true
    //         // });
    //         })
    //         .catch(e => {
    //             console.log(e);
    //         });
    //         });
    //     }



    // AccountDataService.create(data)
    // .then(response => {
    //     //console.log(response.data);
    //     // this.setState({
    //     //     redirect: true
    //     // });
    // })
    // .catch(e => {
    //     console.log(e);
    // });
    //}


    handleTimespanAssignedToArrayChange(selectedIds) {
        console.log("New selected ids: ", selectedIds);

        // let justIds = [];
        // for(let z = 0; z < selectedIds.length; z++) {
        //     justIds.push(parseInt(selectedIds[z].value));     // this is the id number in string form
        // }

        // this.setState({
        //     timespanAssignedToArray: selectedIds // contains both full name and id (as string) at this point
        // });

        store.dispatch(updateTimespanAssignedToArray(selectedIds));
        store.dispatch(alertTimespanAssignedToChange());
    }

    render() {
        if (!this.props.loggedStatus.loggedIn || !this.props.userPermissions.can_process_tickets) {
            return (
                <Redirect to='/' />
            );
        }

        // const { redirect } = this.state;

        // if(redirect) {
        //     return <Redirect to='/accounts'/>   // To redirect back after submission
        // }

        const { colorScheme } = this.props;
        const selectedStyles = colorScheme === 'dark' ? darkStyles : lightStyles;

        return (
            <>
                <Navbar pageTitle="Reports" />
                <div style={{ paddingTop: "15px" }} />
                <Container fluid>
                    {/* <Paper withBorder p="md" radius="md" display="block" m="5px" style={{ verticalAlign: "top" }}> */}
                        {/* <div style={{width: "25%"}}>
                            <Select 
                                label="Tenant"
                                data={this.state.tenants && this.state.tenants.map((tenant) => (
                                    tenant.name_of_tenant
                                ))}
                                value={this.props.loggedStatus.report_tenant_name_selected}
                                onChange={(_value, option) => this.handleReportTenantChange(_value)}
                                allowDeselect={false}
                            />
                        </div> */}
                        {/* <Flex
                            justify="flex-start"
                            align="flex-start"
                            direction="row"
                            gap="md"
                        >
                            {this.state.tenants && this.state.tenants.map((tenant) => (
                                <Button
                                    h="36px"
                                    variant={this.props.loggedStatus.report_tenant_name_selected === tenant.name_of_tenant ? "filled" : "default"}
                                    onClick={() => this.handleReportTenantChange(tenant.name_of_tenant)}
                                >
                                    {tenant.name_of_tenant}
                                </Button>))}
                        </Flex> */}
                    {/* </Paper> */}
                    <Grid style={{marginTop: "15px", marginBottom: "15px"}}>
                        <Grid.Col span={3}>
                            <Center>
                                <NumberOfTicketsLast24Hours/>
                            </Center>
                        </Grid.Col>
                        <Grid.Col span={3}>
                            <Center>
                                <PercentChangeTicketsLast24Hours/>
                            </Center>
                        </Grid.Col>
                        <Grid.Col span={3}>
                            <Center>
                                <NumberOfTicketsLastWeek/>
                            </Center>
                        </Grid.Col>
                        <Grid.Col span={3}>
                            <Center>
                                <PercentChangeTicketsLastWeek/>
                            </Center>
                        </Grid.Col>
                    </Grid>
                    <Paper withBorder p="md" radius="md" display="block" m="5px">
                        <Flex
                            gap="lg"
                        >
                            <div style={{width: "300px"}}>
                                <Select 
                                    label="Tenant"
                                    data={this.state.tenants && this.state.tenants.map((tenant) => (
                                        tenant.name_of_tenant
                                    ))}
                                    value={this.props.loggedStatus.report_tenant_name_selected}
                                    onChange={(_value, option) => this.handleReportTenantChange(_value)}
                                    allowDeselect={false}
                                />
                            </div>
                            <DatePickerInput
                                label="Date Range of Ticket Creation"
                                placeholder="Pick date"
                                w="350px"
                                type="range"
                                value={this.state.timespan}
                                onChange={(e) => {
                                    this.setState({ timespan: e });
                                    // Run async work without blocking the state update
                                    setTimeout(() => {
                                            handleTimespanChange(e);
                                            //this.setState({ timespan: e })
                                    }, 0);
                                }}
                                allowDeselect={false}
                            />
                            <DatePickerInput
                                label="Date Range of Ticket Resolution"
                                placeholder="Pick date"
                                w="350px"
                                type="range"
                                value={this.state.resolved_timespan}
                                onChange={(e) => {
                                    this.setState({ resolved_timespan: e });
                                    // Run async work without blocking the state update
                                    setTimeout(() => {
                                            handleResolvedTimespanChange(e);
                                            //this.setState({ timespan: e })
                                    }, 0);
                                }}
                                allowDeselect={false}
                            />
                            <Select
                                label="Status"
                                placeholder="Pick type"
                                w="150px"
                                value={this.state.timespanType}
                                onChange={(e) => {
                                    this.setState({ timespanType: e });
                                    // Run async work without blocking the state update
                                    setTimeout(() => {
                                            handleTimespanTypeChange(e);
                                            //this.setState({ timespanType: e })
                                    }, 0);
                                }}
                                data={['All', 'Open', 'Resolved']}
                                allowDeselect={false}
                            />
                            {/* <Select
                                label="Assigned To"
                                placeholder="Assigned to"
                                value={
                                    this.state.techList && this.state.techList.length > 0 && this.state.techList.find(v => v.id === this.state.timespanAssignedTo) &&
                                    this.state.techList.find(v => v.id === this.state.timespanAssignedTo).tech_full_name
                                }
                                data={this.state.techList.map((tech) => (tech.tech_full_name))}
                                onChange={(e) => {
                                    let newAssignedToId = this.state.techList.find(t => t.tech_full_name === e).id;
                                    handleTimespanAssignedToChange(newAssignedToId);
                                    this.setState({ timespanAssignedTo: newAssignedToId }, () => this.getTimespanTickets())
                                }}
                                allowDeselect={false}
                            /> */}
                            {/* <MultiSelect 
                                label="Testing"
                                data={['React', 'Javascript']}
                                placeholder="Pick a value"
                            /> */}
                            <div style={{ marginBottom: '1rem' }}>
                                <Text style={{fontSize: '14px'}} fw={500} mb={9}>
                                    Assigned To
                                </Text>
                                <div style={{width: "725px"}}>
                                    <ReactSelect
                                        key={colorScheme}
                                        options={
                                            this.state.techList.map((tech) => ({
                                                value: tech.id.toString(),
                                                label: tech.tech_full_name
                                            }))
                                        }
                                        isMulti
                                        onChange={(e) => {
                                            this.setState({
                                                timespanAssignedToArray: e // contains both full name and id (as string) at this point
                                            });
                                            // Run async work without blocking the state update
                                            setTimeout(() => {
                                                //removed the tokens from all of these timouts
                                                    this.handleTimespanAssignedToArrayChange(e)
                                            }, 0);
                                        }}
                                        value={
                                            this.state.timespanAssignedToArray && this.state.timespanAssignedToArray.map((tech) => ({
                                                value: tech.value.toString(), label: tech.label
                                            }))
                                        }
                                        styles={selectedStyles}
                                    />
                                </div>
                            </div>
                        </Flex>
                    </Paper>
                    <div style={{marginTop: "30px", marginBottom: "30px"}}>
                        <ResolvedTicketCountByTech 
                            props={this.props} 
                            //timespan={this.props.reportSelections.resolved_timespan}
                            //assignedToArray={this.props.reportSelections.timespanAssignedToArray}
                        />
                    </div>
                    <div style={{marginTop: "30px", marginBottom: "30px"}}>
                        <TimespanTickets history={this.props.history} />
                    </div>
                    <div style={{marginTop: "30px", marginBottom: "30px"}}>
                        <ResolvedTickets history={this.props.history} />
                    </div>
                    <div style={{marginTop: "30px", marginBottom: "30px"}}>
                        <OverdueTickets history={this.props.history} />
                    </div>
                    <div style={{marginTop: "30px", marginBottom: "30px"}}>
                        <WarningTickets history={this.props.history} /> 
                    </div>
                    <div style={{marginTop: "30px", marginBottom: "30px"}}>
                        <SurveyResults history={this.props.history} />
                    </div>
                </Container>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,
        userPermissions: state.userPermissions,
        reportSelections: state.reports
    };
}

export default connect(mapStateToProps, { UPDATE_ACTIVE_LINK, SET_REPORT_TENANT_VIEWING, ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN, ALERT_REPORT_TENANT_CHANGE_FROM_DROPDOWN_WARNING_TICKETS, ALERT_REPORT_TIMESPAN_CHANGE_DETECTED, ALERT_REPORT_RESOLVED_TIMESPAN_CHANGE_DETECTED, ALERT_REPORT_TIMESPAN_TYPE_CHANGE_DETECTED, ALERT_REPORT_ASSIGNED_TO_CHANGE_DETECTED, LOGOUT })(Reports);
